export function getAbbrForTimeZone(date: Date, timeZone: string): string {
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone,
    timeZoneName: 'short',
  })

  const parts = formatter.formatToParts(date)
  const abbr = parts.find((p) => p.type === 'timeZoneName')?.value

  return abbr ?? ''
}
